import React, { useState } from "react";
import styled from "styled-components";
import { useCustomTheme } from "./Context/CustomThemeProvider";
import { Sun, Moon } from "lucide-react";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ToggleWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 64px;
  height: 34px;
`;

const HiddenCheckbox = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: #34c759;
  }

  &:checked + span:before {
    transform: translateX(30px);
  }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #d1d1d6;
  transition: 0.3s ease;
  border-radius: 34px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15);

  &:before {
    content: "";
    position: absolute;
    height: 28px;
    width: 28px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    border-radius: 50%;
    transition: 0.3s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text};
  transition: color 0.3s ease;
`;

export default function ThemeToggle() {
  const { theme, setTheme } = useCustomTheme();
  const [darkMode, setDarkMode] = useState(false);
  const isDark = theme === "dark";

  return (
    <Container>
      <ToggleWrapper>
        <HiddenCheckbox
          type="checkbox"
          checked={theme === "dark"}
          onChange={() => setTheme(theme === "dark" ? "light" : "dark")}
        />
        <Slider />
      </ToggleWrapper>
      {isDark ? (
        <IconWrapper>
          <Moon size={20} />
        </IconWrapper>
      ) : (
        <IconWrapper>
          <Sun size={20} />
        </IconWrapper>
      )}
    </Container>
  );
}
